<!--
 * @Description: 异动反馈情况
 * @Author: cxh
 * @Date: 2023-06-19 11:14:17
 * @LastEditTime: 2023-06-21 09:49:49
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table :columns="columns" v-model:search="searchFrom" @fetch="fetch" tableId="ofbuFollowChangeFeedback">
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item :label="t('custom.customerNumber')">
              <a-input v-model:value="searchFrom.customerNumber" :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('custom.arkCode')">
              <a-input v-model:value="searchFrom.arkCode" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('custom.customerName')">
              <a-input v-model:value="searchFrom.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="createTime" :label="t('exception.exceptionTime')">
              <CosRangePicker
                isOutputBeijingTime
                v-model:startTime="searchFrom.startAlarmDate"
                v-model:endTime="searchFrom.endAlarmDate"
              />
            </dc-form-item>
            <dc-form-item name="seller" :label="t('exception.sellerName')">
              <user-select v-model:value="searchFrom.seller" />
            </dc-form-item>
            <dc-form-item :label="t('exception.exceptionType')">
              <CosSelect
                v-model:value="searchFrom.alarmType"
                :placeholder="t('common.pleaseSelect')"
                allowClear
                :options="alarmTypeEnum"
              />
            </dc-form-item>
            <dc-form-item :label="t('exception.exceptionLevel')">
              <CosSelect
                v-model:value="searchFrom.alarmLevelList"
                :placeholder="t('common.pleaseSelect')"
                mode="multiple"
                allowClear
                :options="alarmLevelEnum"
              />
            </dc-form-item>
            <dc-form-item :label="t('exception.followUpDes')">
              <CosSelect
                v-model:value="searchFrom.processStatusList"
                :placeholder="t('common.pleaseSelect')"
                allowClear
                mode="multiple"
                :options="alarmProcessStatusEnum"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <ExportButton
            appId="cos_ofbu"
            taskType="413"
            :search="searchFrom"
            v-permission="'ofbu_followChangeFeedback_export_btn'"
            >{{ t('btn.export') }}</ExportButton
          >
        </template>
        <template #bodyCell="{ column, text }">
          <template v-if="column.dataIndex === 'process'">
            <EditorTableText :value="text" />
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/overseasSales/analysis'
import { listByParamCodes } from '@/api/common'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { useI18n } from 'vue-i18n'
import { alarmTypeEnum, alarmLevelEnum, alarmCustomerLevelEnum, alarmProcessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
export default { name: 'ofbu_followChangeFeedback' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const searchFrom = ref<FollowAlarmParams>({})
const paramCodeData = ref<any>({
  ofbu_change_description: [] // 异动说明
})
const columns = computed(() => [
  {
    title: t('custom.customerNumber'),
    dataIndex: 'customerNumber',
    fixed: 'left',
    width: 200
  },
  {
    title: t('custom.customerName'),
    dataIndex: 'customerName'
  },
  {
    title: t('arkCode.arkCode'),
    dataIndex: 'arkCode'
  },
  {
    title: t('exception.sellerName'),
    dataIndex: 'sellerName'
  },
  {
    title: t('exception.exceptionTime'),
    dataIndex: 'alarmDate'
  },
  {
    title: t('exception.exceptionLevel'),
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: t('custom.customerLevel'),
    dataIndex: 'customerLevel',
    dicData: alarmCustomerLevelEnum
  },
  {
    title: t('exception.exceptionType'),
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: t('exception.exceptionReason'),
    dataIndex: 'alarmInfo'
  },
  {
    title: t('exception.exceptionDes'),
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.ofbu_change_description
  },
  {
    title: t('follow.processDetail'),
    dataIndex: 'process'
  },
  {
    title: t('exception.followUpTime'),
    dataIndex: 'processTime'
  },
  {
    title: t('exception.followUpDes'),
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  followAlarmGet({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
</script>
